module.exports = __webpack_public_path__ + "static/CRM-dla-malych-firm-88c1f21aead8d0f800d0a4498075b881.png";